/* AlarmVideo Redesign — behaviour
   Ported from the Claude Design prototype. Everything the prototype did in
   React state is done here against the real Shopify cart / collection URLs. */
(function () {
  'use strict';

  var cfg = window.AVConfig || {};
  var FREE_SHIPPING = typeof cfg.freeShipping === 'number' ? cfg.freeShipping : 250;
  var SHIPPING_COST = typeof cfg.shippingCost === 'number' ? cfg.shippingCost : 6.95;
  var VAT_RATE = typeof cfg.vatRate === 'number' ? cfg.vatRate : 1.21;

  /* prototype's eur(): "€214,50" — nl-NL grouping, no space after the sign */
  function eur(n) {
    return '€' + Number(n).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fromCents(c) { return Number(c || 0) / 100; }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ---------------------------------------------------------------- nav */

  function initNav() {
    var wrap = $('[data-av-nav]');
    if (!wrap) return;

    function close() {
      $$('[data-av-nav-item]', wrap).forEach(function (b) {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      });
      $$('[data-av-nav-panel]', wrap).forEach(function (p) { p.hidden = true; });
      var scrim = $('[data-av-nav-scrim]', wrap);
      if (scrim) scrim.hidden = true;
    }

    $$('[data-av-nav-item]', wrap).forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-av-nav-item');
        var panel = $('[data-av-nav-panel="' + id + '"]', wrap);
        if (!panel) return;
        var wasOpen = !panel.hidden;
        close();
        if (!wasOpen) {
          panel.hidden = false;
          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          var scrim = $('[data-av-nav-scrim]', wrap);
          if (scrim) scrim.hidden = false;

          /* position the panel under its own trigger — it's sized to its
             content now rather than stretched full-width, so it needs a
             real left offset instead of always sitting at the nav's edge */
          var wrapRect = wrap.getBoundingClientRect();
          var btnRect = btn.getBoundingClientRect();
          var panelWidth = panel.getBoundingClientRect().width;
          var left = btnRect.left - wrapRect.left;
          var maxLeft = wrapRect.width - panelWidth - 8;
          if (left > maxLeft) left = Math.max(8, maxLeft);
          panel.style.left = left + 'px';
        }
      });
    });

    on($('[data-av-nav-scrim]', wrap), 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ----------------------------------------------------------- carousel */
  /* 5s per step, always moving right. The card list is rendered twice, so at
     the halfway mark we rewind by one set — you never see it scroll back. */

  function initRail() {
    var rail = $('[data-av-rail]');
    if (!rail) return;
    var paused = false;

    function step(dir) {
      var card = rail.firstElementChild;
      var w = card ? card.offsetWidth + 12 : 260;
      rail.scrollBy({ left: dir * w, behavior: 'smooth' });
    }

    function tick() {
      if (paused || document.hidden) return;
      var half = rail.scrollWidth / 2;
      if (rail.scrollLeft >= half - 2) {
        rail.scrollTo({ left: rail.scrollLeft - half, behavior: 'auto' });
      }
      step(1);
    }

    on($('[data-av-rail-prev]'), 'click', function () { paused = true; step(-1); });
    on($('[data-av-rail-next]'), 'click', function () { paused = true; step(1); });
    on(rail, 'mouseenter', function () { paused = true; });
    on(rail, 'mouseleave', function () { paused = false; });
    on(rail, 'focusin', function () { paused = true; });

    setInterval(tick, 5000);
  }

  /* ------------------------------------------------------- view toggle */

  function initView() {
    var coll = $('[data-av-coll]');
    if (!coll) return;
    var stored;
    try { stored = localStorage.getItem('av-view'); } catch (e) { stored = null; }
    if (stored === 'grid' || stored === 'table') set(stored);

    function set(v) {
      coll.setAttribute('data-view', v);
      /* not scoped to coll: the toggle buttons live in .av-coll__head, a
         sibling of .av-coll[data-av-coll] — scoping the query to coll found
         zero buttons and silently attached no click listeners at all. */
      $$('[data-av-view]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-av-view') === v);
        b.setAttribute('aria-pressed', String(b.getAttribute('data-av-view') === v));
      });
      try { localStorage.setItem('av-view', v); } catch (e) { /* private mode */ }
    }

    $$('[data-av-view]').forEach(function (btn) {
      on(btn, 'click', function () { set(btn.getAttribute('data-av-view')); });
    });
  }

  /* ------------------------------------------------------ inch filter */
  /* Screen-size range filter (Monitoren). Shopify's native collection
     filters only support exact-match "list" or the built-in price_range —
     no generic numeric range for a custom metafield — so this filters the
     already-rendered cards/rows client-side instead. Only affects products
     on the current page; bump "Artikelen per pagina" for this collection
     if it ever needs to cover more than one page of results. */

  function initInchFilter() {
    var min = $('[data-av-inch-min]');
    var max = $('[data-av-inch-max]');
    if (!min || !max) return;
    var cards = $$('[data-av-inch]');
    if (!cards.length) return;
    var empty = $('[data-av-inch-empty]');

    function apply() {
      var lo = parseFloat(min.value);
      var hi = parseFloat(max.value);
      var visible = 0;
      cards.forEach(function (card) {
        var inch = parseFloat(card.getAttribute('data-av-inch'));
        var ok = (isNaN(lo) || inch >= lo) && (isNaN(hi) || inch <= hi);
        card.hidden = !ok;
        if (ok) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
    }

    /* Mirrored into the URL (not just kept in the inputs) so the filter
       survives a sort change — sort re-navigates the page — and a refresh
       or shared link, the same way Shopify's own native filters do. */
    function syncUrl() {
      var url = new URL(window.location.href);
      if (min.value) url.searchParams.set('inch_min', min.value); else url.searchParams.delete('inch_min');
      if (max.value) url.searchParams.set('inch_max', max.value); else url.searchParams.delete('inch_max');
      history.replaceState(null, '', url);
    }

    function onChange() { apply(); syncUrl(); }

    function step(input, dir) {
      var v = (parseFloat(input.value) || 0) + dir * 0.5;
      if (v < 0) v = 0;
      input.value = (Math.round(v * 10) / 10).toString();
      onChange();
    }

    on(min, 'input', onChange);
    on(max, 'input', onChange);

    /* scroll-to-adjust: up increases, down decreases, without needing to
       click into the field first */
    [min, max].forEach(function (input) {
      on(input, 'wheel', function (e) {
        e.preventDefault();
        step(input, e.deltaY < 0 ? 1 : -1);
      });
    });

    var restored = new URL(window.location.href).searchParams;
    if (restored.has('inch_min')) min.value = restored.get('inch_min');
    if (restored.has('inch_max')) max.value = restored.get('inch_max');
    apply();
  }

  /* -------------------------------------------------------------- sort */
  /* changing sort keeps whatever filters are already in the URL */

  function initSort() {
    var sel = $('[data-av-sort]');
    if (!sel) return;
    on(sel, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      if (Filters.load) Filters.load(url.toString(), true);
      else window.location.href = url.toString();
    });
  }

  /* ----------------------------------------------------------- filters */
  /* Filter chips, the price form, the pager and sort all re-fetch just the
     collection section (Section Rendering API, ?section_id=) and swap the
     markup in place. The page keeps its scroll position instead of
     reloading and jumping back to the top; the URL is still updated so a
     filtered view can be refreshed, shared, or navigated with back/forward. */

  var Filters = {};

  function initFilters() {
    var root = $('[data-av-collection]');
    if (!root || !window.fetch || !window.DOMParser) return;
    var sectionId = root.getAttribute('data-av-section-id');
    if (!sectionId) return;
    var pending = 0;

    function bind() {
      root = $('[data-av-collection]');
      if (!root) return;
      initView();
      initSort();
      initInchFilter();
      bindAddForms(root);

      /* filter chips, "Wissen", pager, "Filters wissen" in the empty state */
      $$('.av-filters a, .av-filters__clear, .av-pager a, .av-empty a', root).forEach(function (a) {
        if (a.dataset.avBound) return;
        a.dataset.avBound = '1';
        on(a, 'click', function (e) {
          var href = a.getAttribute('href');
          if (!href || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          e.preventDefault();
          load(href, true);
        });
      });

      /* price range form */
      $$('[data-av-filter-form]', root).forEach(function (form) {
        if (form.dataset.avBound) return;
        form.dataset.avBound = '1';
        on(form, 'submit', function (e) {
          e.preventDefault();
          var url = new URL(form.getAttribute('action') || window.location.pathname, window.location.href);
          var data = new FormData(form);
          var params = new URLSearchParams();
          data.forEach(function (v, k) { if (v !== '') params.append(k, v); });
          url.search = params.toString();
          load(url.toString(), true);
        });
      });
    }

    function load(href, push) {
      var target = new URL(href, window.location.href);
      /* keep the client-side inch range (it lives in the URL only) */
      var cur = new URL(window.location.href).searchParams;
      ['inch_min', 'inch_max'].forEach(function (k) {
        if (cur.has(k) && !target.searchParams.has(k)) target.searchParams.set(k, cur.get(k));
      });
      var fetchUrl = new URL(target.href);
      fetchUrl.searchParams.set('section_id', sectionId);

      var id = ++pending;
      var main = $('.av-coll__main', root);
      if (main) main.setAttribute('aria-busy', 'true');

      fetch(fetchUrl.href, { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (id !== pending) return; /* a newer request superseded this one */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-av-collection]');
          if (!fresh) throw new Error('no section');
          fresh.classList.remove('av-fade'); /* no re-fade on swap */
          root.replaceWith(fresh);
          if (push) history.pushState({ av: true }, '', target.href);
          bind();
          document.dispatchEvent(new CustomEvent('av:collection', { detail: { url: target.href } }));
        })
        .catch(function () { window.location.href = target.href; });
    }

    Filters.load = load;
    on(window, 'popstate', function () {
      if ($('[data-av-collection]')) load(window.location.href, false);
    });

    bind();
  }

  /* --------------------------------------------------------------- faq */

  function initFaq() {
    $$('[data-av-faq-q]').forEach(function (btn) {
      on(btn, 'click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = !panel.hidden;
        panel.hidden = open;
        btn.setAttribute('aria-expanded', String(!open));
        var sign = $('.av-faq__sign', btn);
        if (sign) sign.textContent = open ? '+' : '–';
      });
    });
  }

  /* ----------------------------------------------------------- gallery */

  function initGallery() {
    var main = $('[data-av-gallery-main]');
    if (!main) return;
    $$('[data-av-gallery-thumb]').forEach(function (btn) {
      on(btn, 'click', function () {
        var src = btn.getAttribute('data-src');
        if (src) { main.src = src; main.removeAttribute('srcset'); }
        $$('[data-av-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* --------------------------------------------------------------- qty */

  function initQty() {
    $$('[data-av-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      function clamp(v) { return Math.max(1, isNaN(v) ? 1 : v); }
      on($('[data-av-qty-dec]', wrap), 'click', function () { input.value = clamp(parseInt(input.value, 10) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
      on($('[data-av-qty-inc]', wrap), 'click', function () { input.value = clamp(parseInt(input.value, 10) + 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
      on(input, 'change', function () { input.value = clamp(parseInt(input.value, 10)); });
    });
  }

  /* -------------------------------------------------------------- cart */

  var Cart = {
    open: function () {
      var d = $('[data-av-drawer]');
      if (!d) return;
      d.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var close = $('[data-av-drawer-close]', d);
      if (close) close.focus();
    },
    close: function () {
      var d = $('[data-av-drawer]');
      if (!d) return;
      d.hidden = true;
      document.documentElement.style.overflow = '';
    },
    fetch: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) { return r.json(); });
    },
    add: function (id, qty) {
      return Cart.addMultiple([{ id: id, quantity: qty || 1 }]);
    },
    addMultiple: function (items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Toevoegen mislukt'); });
        return r.json();
      });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    },
    render: function (cart) {
      var body = $('[data-av-cart-lines]');
      var empty = $('[data-av-cart-empty]');
      if (!body) return;

      var count = cart.item_count;
      $$('[data-av-cart-count]').forEach(function (el) { el.textContent = count; });
      $$('[data-av-cart-title]').forEach(function (el) { el.textContent = 'Wagen — ' + count; });

      if (empty) empty.hidden = count > 0;
      body.innerHTML = '';

      cart.items.forEach(function (item) {
        var unitEx = fromCents(item.final_price) / VAT_RATE;
        var row = document.createElement('div');
        row.className = 'av-line';
        row.innerHTML =
          '<div class="av-line__media">' +
            (item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy">' : '') +
          '</div>' +
          '<div class="av-line__body">' +
            '<div class="av-line__top">' +
              '<a class="av-line__name" href="' + item.url + '"></a>' +
              '<span class="av-line__total">' + eur(fromCents(item.final_line_price)) + '</span>' +
            '</div>' +
            '<span class="av-line__meta"></span>' +
            '<div class="av-line__ctrl">' +
              '<div class="av-line__qty">' +
                '<button type="button" data-dec aria-label="Minder">–</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-inc aria-label="Meer">+</button>' +
              '</div>' +
              '<button type="button" class="av-line__remove" data-remove>Verwijderen</button>' +
            '</div>' +
          '</div>';

        /* textContent, not innerHTML — product titles are merchant data */
        $('.av-line__name', row).textContent = item.product_title;
        $('.av-line__meta', row).textContent =
          [item.vendor, item.sku, eur(unitEx) + ' p/st excl. btw'].filter(Boolean).join(' · ');

        on($('[data-inc]', row), 'click', function () { Cart.update(item.key, item.quantity + 1); });
        on($('[data-dec]', row), 'click', function () { Cart.update(item.key, item.quantity - 1); });
        on($('[data-remove]', row), 'click', function () { Cart.update(item.key, 0); });

        body.appendChild(row);
      });

      var total = fromCents(cart.total_price);
      var ship = total === 0 || total >= FREE_SHIPPING ? 0 : SHIPPING_COST;
      var setText = function (sel, v) { var el = $(sel); if (el) el.textContent = v; };

      setText('[data-av-subtotal]', eur(total));
      setText('[data-av-vat]', eur(total - total / VAT_RATE));
      setText('[data-av-ship]', ship === 0 ? 'Gratis' : eur(ship));
      setText('[data-av-total]', eur(total + ship));
      setText('[data-av-ship-note]', total === 0 || total >= FREE_SHIPPING
        ? 'Gratis verzending · 30 dagen retour · fabrieksgarantie'
        : eur(FREE_SHIPPING - total) + ' meer voor gratis verzending');
    },
    update: function (key, qty) {
      return Cart.change(key, qty).then(Cart.render);
    },
    refresh: function () { return Cart.fetch().then(Cart.render); }
  };

  /* quick-add on every card, and the product page form. Idempotent, so it
     can be re-run on freshly fetched collection markup (see initFilters). */
  function bindAddForms(scope) {
    $$('[data-av-add]', scope).forEach(function (form) {
      if (form.dataset.avBound) return;
      form.dataset.avBound = '1';
      on(form, 'submit', function (e) {
        e.preventDefault();
        var btn = $('[type="submit"]', form) || $('button', form);
        var id = form.querySelector('[name="id"]');
        var qtyEl = form.querySelector('[name="quantity"]');
        if (!id) return;
        var label = btn ? btn.textContent : '';
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Bezig…'; }
        Cart.add(id.value, qtyEl ? parseInt(qtyEl.value, 10) : 1)
          .then(function () { return Cart.refresh(); })
          .then(function () { Cart.open(); })
          .catch(function (err) {
            var note = $('[data-av-add-error]', form);
            if (note) { note.textContent = err.message; note.hidden = false; }
            else alert(err.message);
          })
          .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.textContent = label; } });
      });
    });
  }

  function initCart() {
    on($('[data-av-cart-open]'), 'click', function (e) { e.preventDefault(); Cart.open(); });
    on($('[data-av-drawer-close]'), 'click', Cart.close);
    on($('[data-av-drawer-scrim]'), 'click', Cart.close);
    on(document, 'keydown', function (e) {
      var d = $('[data-av-drawer]');
      if (e.key === 'Escape' && d && !d.hidden) Cart.close();
    });

    bindAddForms(document);

    if ($('[data-av-cart-lines]')) Cart.refresh();
  }

  /* --------------------------------------------------- bundle checkout */
  /* "Vaak samen besteld" curated bundle: checkbox rows -> running total,
     one request adds every checked item at once. The image and title in
     each row are plain links to the product; only the checkbox selects. */
  function initBundle() {
    $$('[data-av-bundle]').forEach(function (bundle) {
      var checks = $$('[data-av-bundle-check]', bundle);
      var countEl = $('[data-av-bundle-count]', bundle);
      var totalEl = $('[data-av-bundle-total]', bundle);
      var addBtn = $('[data-av-bundle-add]', bundle);

      function sync() {
        var checked = checks.filter(function (c) { return c.checked; });
        var totalCents = checked.reduce(function (sum, c) { return sum + (parseInt(c.dataset.price, 10) || 0); }, 0);
        if (countEl) countEl.textContent = checked.length;
        if (totalEl) totalEl.textContent = eur(fromCents(totalCents));
        if (addBtn) addBtn.disabled = checked.length === 0;
      }

      checks.forEach(function (c) { on(c, 'change', sync); });
      sync();

      on(addBtn, 'click', function () {
        var checked = checks.filter(function (c) { return c.checked; });
        if (!checked.length) return;
        var label = addBtn.textContent;
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.textContent = 'Bezig…';
        Cart.addMultiple(checked.map(function (c) { return { id: c.value, quantity: 1 }; }))
          .then(function () { return Cart.refresh(); })
          .then(function () { Cart.open(); })
          .catch(function (err) { alert(err.message); })
          .then(function () { addBtn.removeAttribute('aria-busy'); addBtn.textContent = label; });
      });
    });
  }

  /* ---------------------------------------------------------- callback */
  /* live summary panel: "Wij bellen u dinsdag 8 sep tussen 10:00 – 12:00 op …"

     Submission stays a normal full-page POST (see av-callback.liquid for
     why: Shopify's bot-protection CAPTCHA token only gets attached during a
     native submit, so intercepting it to POST via fetch gets rejected). */

  function initCallback() {
    var form = $('[data-av-callback]');
    if (!form) return;

    function pick(group) {
      var el = form.querySelector('[data-av-cb-group="' + group + '"] .av-chip.is-active');
      return el ? { value: el.getAttribute('data-value'), label: el.getAttribute('data-label') || el.textContent.trim() } : null;
    }

    $$('[data-av-cb-group]', form).forEach(function (group) {
      $$('.av-chip', group).forEach(function (chip) {
        on(chip, 'click', function () {
          $$('.av-chip', group).forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');
          var hidden = group.querySelector('input[type="hidden"]');
          if (hidden) hidden.value = chip.getAttribute('data-value') || '';
          sync();
        });
      });
    });

    function setRow(key, value, filled) {
      var el = form.querySelector('[data-av-cb-summary="' + key + '"]');
      if (!el) return;
      el.textContent = value;
      el.classList.toggle('is-empty', !filled);
    }

    function sync() {
      var topic = pick('onderwerp');
      var day = pick('dag');
      var slot = pick('tijdvak');
      var phone = form.querySelector('[name="contact[telefoon]"]');
      var phoneVal = phone ? phone.value.trim() : '';

      setRow('onderwerp', topic ? topic.label : 'nog niet gekozen', !!topic);
      setRow('dag', day ? day.label : 'nog niet gekozen', !!day);
      setRow('tijdvak', slot ? slot.label : 'nog niet gekozen', !!slot);
      setRow('telefoon', phoneVal || 'nog niet ingevuld', !!phoneVal);

      var hint = form.querySelector('[data-av-cb-hint]');
      if (hint) {
        hint.textContent = !phoneVal
          ? 'Vul uw telefoonnummer in — dag en tijdvak zijn optioneel.'
          : (!day || !slot
            ? 'Zonder dag of tijdvak bellen we de eerstvolgende werkdag.'
            : 'Wij bellen binnen het gekozen tijdvak.');
      }
    }

    $$('input, textarea', form).forEach(function (i) { on(i, 'input', sync); });
    sync();
  }

  /* ------------------------------------------------------ sticky offset */
  /* #header-group is the sticky element (see av.css for why it has to be
     that one and not .av-header) — its rendered height varies (nav wraps
     to a second row on narrower widths, mobile stacks the search field),
     so the filters bar reads it here instead of a fixed guess, to know how
     far down to stick itself. */

  function initStickyOffset() {
    var header = document.getElementById('header-group');
    if (!header) return;

    function set() {
      document.documentElement.style.setProperty('--av-header-h', header.getBoundingClientRect().height + 'px');
    }

    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(header);
    else on(window, 'resize', set);
  }

  /* -------------------------------------------------------------- boot */

  function boot() {
    initNav(); initRail(); initFaq();
    initGallery(); initQty(); initCart(); initBundle(); initCallback();
    initStickyOffset();
    /* collection pages: initFilters binds view/sort/inch itself so they can
       be re-bound after every in-place section swap; elsewhere bind once */
    if ($('[data-av-collection]')) initFilters();
    else { initView(); initSort(); initInchFilter(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.AV = { cart: Cart, eur: eur, filters: Filters };
})();
